import React, { useEffect } from "react";
import { Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@hooks/useQuery";
import SpotlightCards from "./SpotlightCards";
import SpotlightPage from "./SpotlightPage";
import Highlight from "./Highlight";
import AddEditPage from "./AddEditPage";

const Spotlight: React.FC = () => {
  const navigate = useNavigate();
  const query = useQuery();

  const spotlightItems = [
    { label: "Cards", key: "spotlightCards", children: <SpotlightCards /> },
    { label: "Page", key: "spotlightPage", children: <AddEditPage /> },
    { label: "Highlight", key: "highlight", children: <Highlight /> },
  ];

  return (
    <Tabs
      activeKey={query.get('subActiveTab')}
      items={spotlightItems}
      onChange={(subKey) => {
        navigate(`${window.location.pathname}?activeTab=spotlight&subActiveTab=${subKey}`);
      }}
    />
  );
};

export default Spotlight;
